<template>
  <sc-card
    :title="$t(layer_id)"
    :titleIcon="titleIcon"
    v-if="layer_id && id && data"
    bg-color="bg_panel_primary"
    footer
  >
    <div class="sc-object-card">
      <el-collapse class="r-collapse style-collapse" v-model="activeTabs">
        <el-collapse-item name="main" v-if="cardData && cardData.main">
          <template slot="title">
            <r-title type="subtitle-2">{{ $t(`main`) }}</r-title>
          </template>
          <sc-object-card-list :fields="cardData.main" />
        </el-collapse-item>

        <el-collapse-item
          name="cameras"
          v-if="cardData && cardData.camerasList"
        >
          <template slot="title">
            <r-title type="subtitle-2">{{ $t(`cameras`) }}</r-title>
          </template>
          <sc-object-card-list-cameras
            :fields="JSON.parse(cardData.camerasList)"
          />
        </el-collapse-item>

        <el-collapse-item name="macrocam" v-if="cardData && cardData.macroCam">
          <template slot="title">
            <r-title type="subtitle-2">{{ $t(`camera`) }}</r-title>
          </template>
          <sc-object-card-macro-cam
            :id="cardData.macroCam"
            :fields="cardData.main"
          />
        </el-collapse-item>

        <el-collapse-item
          name="tracks"
          v-if="!!trackLayer && trackLayer.track_url"
        >
          <template slot="title">
            <r-title type="subtitle-2">{{ $t(`tracks`) }}</r-title>
          </template>
          <sc-object-card-tracks-controller
            :track-url="trackLayer.track_url"
            :layer_id="trackLayer.layer_id"
            :id="id"
            :uid="data.uid ? String(data.uid) : null"
          />
        </el-collapse-item>

        <el-collapse-item name="stops" v-if="requestToInfo">
          <template slot="title">
            <r-title type="subtitle-2">{{ $t(`more`) }}</r-title>
          </template>
          <sc-object-card-stops :id="id" />
        </el-collapse-item>

        <el-collapse-item name="image" v-if="hasImage">
          <template slot="title">
            <r-title type="subtitle-2">{{ $t(`image`) }}</r-title>
          </template>
          <sc-object-card-image :id="id" :data="data" />
        </el-collapse-item>

        <el-collapse-item
          v-for="(item, i) in meteoDataList"
          :key="item.title + i"
          :name="item.title"
        >
          <template slot="title">
            <r-title type="subtitle-2">{{ $t(`${item.title}`) }}</r-title>
          </template>
          <sc-object-card-list :fields="item.list" />
        </el-collapse-item>

        <el-collapse-item
          name="hard_cameras"
          v-if="cardData && cardData.hard_cameras"
        >
          <template slot="title">
            <r-title type="subtitle-2">{{ $t(`cameras`) }}</r-title>
          </template>
          <sc-object-card-hard-cameras :data="data.data" />
        </el-collapse-item>

        <sc-object-card-chart
          v-if="chartOptions"
          :data="chartOptions"
          :card-data="cardData.main"
          :id="objectId"
        />
      </el-collapse>
    </div>
    <div class="sc-object-card__close-control" @click="closeObjectCard">
      <r-icon name="close-delete" :size="24" />
    </div>
    <sc-object-card-actions slot="footer" :info="objectCard" />
  </sc-card>
</template>

<script>
import scCard from "../../layout/card";
import scObjectCardActions from "./components/object-card-actions";
import scObjectCardList from "./components/object-card-list";
import scObjectCardListCameras from "./components/object-card-list-cameras";
import scObjectCardMacroCam from "./components/object-card-macro-cam";
import scObjectCardTracksController from "./components/object-card-track-controller";
import scObjectCardImage from "./components/object-card-image";
import scObjectCardHardCameras from "./components/object-card-hard-cameras";
import scObjectCardChart from "./components/object-card-chart";
import scObjectCardStops from "./components/object-card-stops";
import { dataMapping, getWidgetStyleConfig } from "../../../configs";

export default {
  components: {
    scCard,
    scObjectCardActions,
    scObjectCardList,
    scObjectCardListCameras,
    scObjectCardMacroCam,
    scObjectCardTracksController,
    scObjectCardImage,
    scObjectCardHardCameras,
    scObjectCardChart,
    scObjectCardStops
  },
  data() {
    return {
      refreshData: null,
      activeTabs: [
        "main",
        "cameras",
        "tracks",
        "camera",
        "road",
        "air",
        "image",
        "macrocam",
        "hard_cameras"
      ]
    };
  },
  watch: {
    id: {
      handler: function(val) {
        if (val && this.layer_id === "chsmeo_traffic_light") {
          this.getData();
          this.refreshData = setInterval(this.getData, 10000);
        }
        this.clearTrack();
        if (this.layer_id !== "chsmeo_traffic_light" && this.refreshData)
          clearInterval(this.refreshData);
        if (!val) clearInterval(this.refreshData);
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    mapInstanceConfig() {
      return this.$store.state.situationCenter.config
        ? this.$store.state.situationCenter.config.mapLayers
        : [];
    },
    layerConfig() {
      return this.mapInstanceConfig
        ? this.mapInstanceConfig.find(e => e.layer_id === this.layer_id)
        : null;
    },
    trackLayer() {
      return this.mapInstanceConfig
        ? this.mapInstanceConfig.find(
            e => e.layer_id === this.layer_id && e.track_url
          )
        : false;
    },
    isEventLayer() {
      return this.mapInstanceConfig
        ? !!this.mapInstanceConfig.find(
            e => e.layer_id === this.layer_id && e.event_layer
          )
        : false;
    },
    requestToInfo() {
      return this.mapInstanceConfig
        ? !!this.mapInstanceConfig.find(
            e => e.layer_id === this.layer_id && e.requestToInfo
          )
        : false;
    },
    hasImage() {
      return this.mapInstanceConfig
        ? !!this.mapInstanceConfig.find(
            e => e.layer_id === this.layer_id && e.has_image
          )
        : false;
    },
    chartOptions() {
      return this.layerConfig ? this.layerConfig.cardChart : null;
    },
    objectCard() {
      return this.$store.state.situationCenter.objectCard;
    },
    layer_id() {
      return this.objectCard.layer_id;
    },
    id() {
      return this.objectCard.id;
    },
    objectId() {
      return this.id.split("id:")[1];
    },
    data() {
      return this.objectCard.data ? this.objectCard.data.properties : null;
    },
    titleColor() {
      let type = "";
      let pdkCams = [];

      switch (this.layer_id) {
        case "chsmeo_traffic_light":
          type = this.data.mode === "нет ошибок" ? "work" : "error";
          break;
        case "chsmeo_cams":
          pdkCams = JSON.parse(this.data.pdk_cams);

          type = !pdkCams.length
            ? "inactive"
            : pdkCams.some(n => !n.status)
            ? "error"
            : "work";
          break;
        case "chsmeo_wialon_tracks":
          type = this.data.organization;
          break;
        case "chsmeo_ngpt":
          type = this.data.type;
          break;
        case "TagilDetector":
          type = this.data.is_active ? "work" : "error";
          break;
        case "TagilPublicTransport?format=vehicles":
          type = this.data.name;
          break;
        case "TagilPublicTransport?format=dit":
          type = this.data.is_active ? "work" : "error";
          break;
        default:
          type = "default";
          break;
      }

      const layerStyle = getWidgetStyleConfig(this.layer_id);

      return layerStyle ? layerStyle.colors[type] : layerStyle.colors.default;
    },
    titleIcon() {
      const layerStyle = getWidgetStyleConfig(this.layer_id);
      let iconByType;

      if (this.layer_id === "TagilPublicTransport?format=vehicles") {
        iconByType = layerStyle.icons[this.data.name];
      }
      return {
        name: iconByType || layerStyle.icons.default,
        color: this.titleColor || null
      };
    },
    cardData() {
      return this.data
        ? dataMapping(
            this.data,
            this.isEventLayer ? "events" : this.layer_id,
            "object_card"
          )
        : {};
    },
    meteoDataList() {
      if (!this.cardData || !this.cardData.meteoData) return [];
      const meteoData = JSON.parse(this.cardData.meteoData);
      const roadDataObject = meteoData.road[0];
      const roadDataKeys = Object.keys(roadDataObject);
      const roadDataList = roadDataKeys
        .filter(e => e !== "id" && e !== "date")
        .map(e => {
          return {
            type: roadDataObject[e][1],
            value: `${roadDataObject[e][0]} ${roadDataObject[e][2]}`
          };
        });
      const airDataObject = meteoData.air[0];
      const airDataKeys = Object.keys(airDataObject);
      const airDataList = airDataKeys
        .filter(e => e !== "id" && e !== "date")
        .map(e => {
          return {
            type: airDataObject[e][1],
            value: `${airDataObject[e][0]} ${airDataObject[e][2]}`
          };
        });

      return [
        { title: "road", list: roadDataList },
        { title: "air", list: airDataList }
      ];
    }
  },
  methods: {
    closeObjectCard() {
      this.$store.commit("SET_SI_CENTER_OBJECT_CARD", {
        layer_id: "",
        id: "",
        data: null
      });

      this.clearTrack();
    },
    clearTrack() {
      this.$store.commit("SET_SI_CENTER_TRACK_LAYER", {
        layer_id: null,
        data: null
      });
    },
    async getData() {
      try {
        const { data } = await this.$store.dispatch("REQUEST", {
          url: "chsmeo_traffic_light"
        });
        if (!data) return;
        const item = Object.values(data).find(
          e => String(e.id) === this.objectId
        );
        if (!item.phase) return;
        this.objectCard.data.properties.phase = item.phase;
      } catch (e) {
        console.log(e);
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.refreshData);
  }
};
</script>

<style lang="scss">
.sc-object-card {
  position: relative;
  width: calc(100% + 40px);
  max-height: calc(100vh - 500px);
  min-height: 320px;
  height: auto;
  overflow: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .el-collapse {
    &.r-collapse {
      height: 100%;
      overflow: auto;
      .el-collapse-item__header {
        padding: 8px;
      }
      .el-collapse-item__content {
        padding-bottom: 12px;
      }
    }
    &-item {
      border-radius: var(--border-radius);
      background-color: var(--bg_containers) !important;
      margin-bottom: 6px;
      &:last-child {
        margin-bottom: 0;
      }
      &__header {
        line-height: 1.5 !important;
      }
    }
  }
}
.sc-object-card__close-control {
  cursor: pointer;
  position: absolute;
  top: -32px;
  right: 8px;
  .r-icon__svg.primary {
    fill: var(--text_secondary) !important;
  }
}
</style>

<i18n>
{
  "ru": {
    "camera": "Камера",
    "cameras": "Камеры",
    "main": "Основное",
    "tracks": "Треки",
    "image": "Отображение направления",
    "road": "Данные по состоянию дорожного полотна",
    "air": "Данные по состоянию воздуха"
  },
  "en": {
    "camera": "Camera",
    "cameras": "Cameras",
    "main": "Main",
    "tracks": "Tracks",
    "image": "Direction display",
    "road": "Road surface data",
    "air": "Air data"
  }
}
</i18n>
